import Page2020 from './Page2020';
export default Page2020;
